<div class="card shadow">
  <div class="card-header bg-secondary text-white">
    <h5 class="mb-0">આંગણવાડી કેન્દરોની વિગતવાર માહિતી</h5>
  </div>
  <div class="card-body dahod-dashboard">
    <div class="row g-2 align-items-center compact-inputs dropdown-pd-none">
      <div class="col-12 col-md-6 col-xl-2 mb-3">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="w-100"
        >
          <mat-label>તારીખથી (From Date)</mat-label>
          <input
            matInput
            type="date"
            id="fromDate"
            [(ngModel)]="form['startDate']"
            #fromDatePicker
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="fromDatePicker.showPicker()"
            aria-label="Open date picker"
            class="icon-pd-none"
          >
            <mat-icon class="icon-compact text-secondary">event</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 col-xl-2 mb-3">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="w-100"
        >
          <mat-label>તારીખ સુધી (To Date)</mat-label>
          <input
            matInput
            type="date"
            id="toDate"
            [(ngModel)]="form['endDate']"
            #toDatePicker
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="toDatePicker.showPicker()"
            aria-label="Open date picker"
            class="icon-pd-none"
          >
            <mat-icon class="icon-compact text-secondary"> event </mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 col-xl-4 mb-3">
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="w-100"
        >
          <mat-label>વિસ્તાર પસંદ કરો (District / Block / Sector)</mat-label>
          <mat-select [(ngModel)]="tempSelectedArea">
            <mat-option [value]="'sector'" [disabled]="true">
              -વિસ્તાર પસંદ કરો-
            </mat-option>

            <mat-option *ngFor="let area of areaOptions" [value]="area.value">
              {{ area.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-auto mb-3">
        <button mat-raised-button color="primary" (click)="onFilter()">
          ફિલ્ટર કરો
        </button>
      </div>

      <div class="col-auto mb-3">
        <button mat-stroked-button color="primary" (click)="exportPDFData()">
          ડાઉનલોડ PDF
        </button>
      </div>
    </div>
    <div class="table-responsive-container">
      <table
        class="table table-bordered table-sm text-center align-middle mb-0"
      >
        <thead class="table-light">
          <tr>
            <th
              class="sticky-col first-col"
              [style]="getStickyStyle(0)"
              rowspan="2"
            >
              #
            </th>

            <ng-container *ngIf="form.selectedArea === 'district'">
              <th
                class="sticky-col second-col"
                [style]="getStickyStyle(1)"
                rowspan="2"
              >
                જિલ્લો
              </th>
              <th
                class="sticky-col third-col"
                [style]="getStickyStyle(2)"
                rowspan="2"
              >
                કુલ બ્લોક
              </th>
              <th
                class="sticky-col fourth-col"
                [style]="getStickyStyle(3)"
                rowspan="2"
              >
                કુલ સેજા
              </th>
              <th
                class="sticky-col fifth-col"
                [style]="getStickyStyle(4)"
                rowspan="2"
              >
                કુલ આંગણવાડી કેન્દ્રોની સંખ્યા
              </th>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'block'">
              <th
                class="sticky-col second-col"
                [style]="getStickyStyle(1)"
                rowspan="2"
              >
                બ્લોક
              </th>
              <th
                class="sticky-col third-col"
                [style]="getStickyStyle(2)"
                rowspan="2"
              >
                કુલ સેજા
              </th>
              <th
                class="sticky-col fourth-col"
                [style]="getStickyStyle(3)"
                rowspan="2"
              >
                કુલ આંગણવાડી કેન્દ્રોની સંખ્યા
              </th>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'sector'">
              <th
                class="sticky-col second-col"
                [style]="getStickyStyle(1)"
                rowspan="2"
              >
                સેજા
              </th>
              <th
                class="sticky-col third-col"
                [style]="getStickyStyle(2)"
                rowspan="2"
              >
                કુલ આંગણવાડી કેન્દ્રોની સંખ્યા
              </th>
            </ng-container>

            <th colspan="2">આંગણવાડી ખુલ્લું છે?</th>
            <th rowspan="2">સવારનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
            <th colspan="2">સવારના નાસ્તાની ડીશનો ફોટો</th>
            <th colspan="2">બાળકોનો સવારનો નાસ્તો લેતા ફોટો</th>
            <th rowspan="2">દૂધ સંજીવની લાભ લેતા બાળકો</th>
            <th colspan="2">દૂધ સંજીવની ફોટો</th>
            <th rowspan="2">બપોરનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
            <th colspan="2">બપોરના નાસ્તાની ડીશ</th>
            <th colspan="2">બપોરનો નાસ્તો જમતા બાળકોનો ફોટો</th>
            <th rowspan="2">પોષણ સુધા યોજનાનો લાભ લેતા લાભાર્થીની સંખ્યા</th>
            <th colspan="2">પોષણ સુધા લાભ ફોટો</th>
            <th rowspan="2">પૂર્વ પ્રાથમિક શિક્ષણ આપેલ બાળકો</th>
            <th colspan="2">પૂર્વ પ્રાથમિક શિક્ષણ ફોટો</th>
            <th colspan="3">ભોજનની ગુણવત્તા</th>
          </tr>

          <tr class="header">
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>હા</th>
            <th>ના</th>
            <th>સારી</th>
            <th>મધ્યમ</th>
            <th>ખરાબ</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of dahodDataList; let i = index">
            <td class="sticky-col first-col" [style]="getStickyStyle(0)">
              {{ i + 1 }}
            </td>

            <ng-container *ngIf="form.selectedArea === 'district'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                Dahod
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ row.totalBlock }}
              </td>
              <td class="sticky-col fourth-col" [style]="getStickyStyle(3)">
                {{ row.totalSector }}
              </td>
              <td class="sticky-col fifth-col" [style]="getStickyStyle(4)">
                {{ row.totalCenter }}
              </td>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'block'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                {{ row.blockName }}
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ row.totalSector }}
              </td>
              <td class="sticky-col fourth-col" [style]="getStickyStyle(3)">
                {{ row.totalCenter }}
              </td>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'sector'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                {{ row.sectorName }}
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ row.totalCenter }}
              </td>
            </ng-container>

            <td>{{ row.openCentersYes }}</td>
            <td>{{ row.openCentersNo }}</td>
            <td>{{ row.morningMealCount }}</td>
            <td>{{ row.morningDishYes }}</td>
            <td>{{ row.morningDishNo }}</td>
            <td>{{ row.childrenMorningMealYes }}</td>
            <td>{{ row.childrenMorningMealNo }}</td>
            <td>{{ row.milkPouchCount }}</td>
            <td>
              {{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes }}
            </td>
            <td>
              {{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo }}
            </td>
            <td>{{ row.afternoonMealCount }}</td>
            <td>{{ row.afternoonDishYes }}</td>
            <td>{{ row.afternoonDishNo }}</td>
            <td>{{ row.afternoonEatYes }}</td>
            <td>{{ row.afternoonEatNo }}</td>
            <td>{{ row.poshanDish }}</td>
            <td>
              {{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementYes }}
            </td>
            <td>
              {{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementNo }}
            </td>
            <td>{{ row.preEducationCount }}</td>
            <td>{{ row.preEducationYes }}</td>
            <td>{{ row.preEducationNo }}</td>
            <td>{{ row.qualityOfHotSnacksAndNutritionEnhancedMealsGood }}</td>
            <td>
              {{ row.qualityOfHotSnacksAndNutritionEnhancedMealsAverage }}
            </td>
            <td>{{ row.qualityOfHotSnacksAndNutritionEnhancedMealsBad }}</td>
          </tr>

          <!-- Total Row -->
          <tr class="table-secondary fw-bold">
            <td class="sticky-col first-col" [style]="getStickyStyle(0)"></td>

            <ng-container *ngIf="form.selectedArea === 'district'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                Total
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ getTotal("totalBlock") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalBlock", 21) }})</small
                >
              </td>
              <td class="sticky-col fourth-col" [style]="getStickyStyle(3)">
                {{ getTotal("totalSector") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalSector", 122) }})</small
                >
              </td>
              <td class="sticky-col fifth-col" [style]="getStickyStyle(4)">
                {{ getTotal("totalCenter") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalCenter", 3056) }})</small
                >
              </td>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'block'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                Total
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ getTotal("totalSector") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalSector", 122) }})</small
                >
              </td>
              <td class="sticky-col fourth-col" [style]="getStickyStyle(3)">
                {{ getTotal("totalCenter") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalCenter", 3056) }})</small
                >
              </td>
            </ng-container>

            <ng-container *ngIf="form.selectedArea === 'sector'">
              <td class="sticky-col second-col" [style]="getStickyStyle(1)">
                Total
              </td>
              <td class="sticky-col third-col" [style]="getStickyStyle(2)">
                {{ getTotal("totalCenter") }}<br /><small class="text-muted"
                  >({{ getPercentageOfCenters("totalCenter", 3056) }})</small
                >
              </td>
            </ng-container>

            <td>
              {{ getTotal("openCentersYes") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "openCentersYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("openCentersNo") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "openCentersNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("morningMealCount") }}</td>
            <td>
              {{ getTotal("morningDishYes") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "morningDishYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("morningDishNo") }}</td>
            <td>
              {{ getTotal("childrenMorningMealYes") }}<br /><small
                class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "childrenMorningMealYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("childrenMorningMealNo") }}<br /><small
                class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "childrenMorningMealNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("milkPouchCount") }}</td>
            <td>
              {{
                getTotal(
                  "photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes"
                )
              }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{
                getTotal(
                  "photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo"
                )
              }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("afternoonMealCount") }}</td>
            <td>
              {{ getTotal("afternoonDishYes") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "afternoonDishYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("afternoonDishNo") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "afternoonDishNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("afternoonEatYes") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "afternoonEatYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("afternoonEatNo") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "afternoonEatNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("poshanDish") }}</td>
            <td>
              {{
                getTotal(
                  "photoOfBeneficiariesPresentForTheNutritionEnhancementYes"
                )
              }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "photoOfBeneficiariesPresentForTheNutritionEnhancementYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{
                getTotal(
                  "photoOfBeneficiariesPresentForTheNutritionEnhancementNo"
                )
              }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "photoOfBeneficiariesPresentForTheNutritionEnhancementNo",
                    3056
                  )
                }})</small
              >
            </td>
            <td>{{ getTotal("preEducationCount") }}</td>
            <td>
              {{ getTotal("preEducationYes") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "preEducationYes",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("preEducationNo") }}<br /><small class="text-muted"
                >({{
                  getPercentageOfCenters(
                    "preEducationNo",
                    getEffectiveBase(3056)
                  )
                }})</small
              >
            </td>
            <td>
              {{ getTotal("qualityOfHotSnacksAndNutritionEnhancedMealsGood") }}
            </td>
            <td>
              {{
                getTotal("qualityOfHotSnacksAndNutritionEnhancedMealsAverage")
              }}
            </td>
            <td>
              {{ getTotal("qualityOfHotSnacksAndNutritionEnhancedMealsBad") }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>